import React from 'react';
import { DownloadIcon, FileTextIcon } from 'lucide-react';
import { brochures } from '../../data/resources';
import { PackForm } from '../forms/PackForm';
import { Reveal } from '../ui/Reveal';
import { SectionHeader } from '../ui/SectionHeader';
import { SupplyTag } from '../ui/SupplyTag';
export function Resources() {
  return <section id="resources" aria-labelledby="resources-title" className="bg-afb-light" data-id="element-459" data-mp="14z5njjylupvn">
      <div className="mx-auto grid max-w-page gap-12 px-5 py-20 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:px-8 lg:py-28" data-id="element-460" data-mp="1iynb5w05zx3f">
        <div data-id="element-461" data-mp="1exuy0ro6981v">
          <Reveal data-id="element-462" data-mp="1ew0n866m6wbi">
            <SectionHeader id="resources-title" title="Brochures & capability packs" intro="The documents buyers pass around for internal sign-off and tender files." data-id="element-463" data-mp="1spi4tlfqpyyw" />
          </Reveal>

          <ul className="mt-10 divide-y divide-afb-line border-y border-afb-line" data-id="element-464" data-mp="22oqui23korfg">
            {brochures.map((brochure, index) => <li key={brochure.id} data-id="element-465" data-mp="1xmi3vce6a1gi" data-mpi={index}>
                <Reveal delay={index * 50} className="flex items-start gap-4 py-6" data-id="element-466" data-mp="1ajt801bcv221">
                  <FileTextIcon aria-hidden="true" className="mt-0.5 h-6 w-6 shrink-0 text-afb-ink/40" data-id="element-467" data-mp="1fi35iikjyeqt" />
                  <div className="flex-1" data-id="element-468" data-mp="1jk7v967vqr86">
                    <h3 className="font-sora text-lg font-semibold" data-id="element-469" data-mp="1jieolqx9o706">{brochure.title}</h3>
                    <p className="mt-1 text-[15px] text-afb-muted" data-id="element-470" data-mp="1ojuafl79qhjm">{brochure.summary}</p>
                  </div>
                  {brochure.href ? <a href={brochure.href} download className="inline-flex shrink-0 items-center gap-1.5 rounded-btn border border-afb-ink/15 bg-white px-3.5 py-2 text-sm font-semibold text-afb-ink transition-colors duration-150 hover:border-afb-ink/40" data-id="element-471" data-mp="1yh8oje5pyu8r">
                      <DownloadIcon aria-hidden="true" className="h-4 w-4" data-id="element-472" data-mp="2c9oou778ke5z" />
                      PDF
                    </a> : <span className="shrink-0" data-id="element-473" data-mp="h5gsuq2vdkrn">
                      <SupplyTag label="PDF link supplied" data-id="element-474" data-mp="h68pm487doji" />
                    </span>}
                </Reveal>
              </li>)}
          </ul>
        </div>

        <Reveal delay={80} data-id="element-475" data-mp="qwbryv17seui">
          <div id="capability-pack" className="rounded-card bg-afb-ink p-6 text-white md:p-10 lg:sticky lg:top-28" data-id="element-476" data-mp="qwl7tpsjp5mh">
            <h3 className="font-sora text-2xl font-semibold" data-id="element-477" data-mp="m2h2tc2ub7o1">Email me the pack</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-white/70" data-id="element-478" data-mp="zu5bf5dvre09">
              Every brochure plus the capability overview, in one email. Ready to forward to your team or attach to a
              tender file.
            </p>
            <div className="mt-8" data-id="element-479" data-mp="14vb4j4bgd3ab">
              <PackForm data-id="element-480" data-mp="14w32glsivd3r" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}